// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2oJ1l","boxTitle":"Qualiphy_boxTitle__3ESd3","box":"Qualiphy_box__1cSwT","toggleWrap":"Qualiphy_toggleWrap__6fNQL"};